import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const fieldTypeSlice = createSlice({
  name: "fieldType",
  initialState,
  reducers: {
    // create
    createFieldTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createFieldTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createFieldTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateFieldTypeState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateFieldTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateFieldTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateFieldTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateFieldTypeState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // delete
    deleteFieldTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteFieldTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteFieldTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteFieldTypeState(state) {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  createFieldTypeStart,
  createFieldTypeSuccess,
  createFieldTypeFailure,
  resetCreateFieldTypeState,
  updateFieldTypeStart,
  updateFieldTypeSuccess,
  updateFieldTypeFailure,
  resetUpdateFieldTypeState,
  deleteFieldTypeStart,
  deleteFieldTypeSuccess,
  deleteFieldTypeFailure,
  resetDeleteFieldTypeState,
} = fieldTypeSlice.actions;

export default fieldTypeSlice.reducer;
